export default "__VITE_ASSET__CSCLpKBF__"